/**
 * Theme: Classic
 * - This theme is the default theme for the Floating Awesome Button.
 * - You can define the theme in the backend: Setting > Design > Template > Name.
 */
export class Classic_Theme {
  /**
   * Get styles object
   * @param {Object} styles
   * @returns {Object}
   */
  static get_styles_object(styles) {
    // For FAB collection force non white color, because the container is white.
    if (!styles.singleType) {
      if (styles.icon.color === '#fff') {
        styles.icon.color = '';
      }

      if (styles.tooltip.font.color === '#fff') {
        styles.tooltip.font.color = '';
      }
    }

    // Set tooltip font color.
    styles.tooltip.font.color = styles.tooltip.font.color ? styles.tooltip.font.color : styles.icon.color;

    return styles;
  }
}
